import { Link } from "react-router-dom";
import { PageFrame, Seo } from "../../kit.jsx";
import "./learn.css";

export default function LearnNotFound({ kind = "guide" }) {
  const back = kind === "problem" ? ["/problems", "See all problem areas"] : ["/guides", "Open the field manual"];
  return (
    <PageFrame className="rd-page learn-page lb-missing">
      <Seo title="Page not found" path="/404" description="This Project GRID page could not be found." />
      <main className="lb-missing__body">
        <p className="lb-mono">Not found</p>
        <h1>We could not find that {kind}.</h1>
        <p>The link may be old or mistyped. The full list is one click away.</p>
        <div className="gh-actions">
          <Link className="gh-btn gh-btn--fill" to={back[0]}>
            <span className="roll" data-label={back[1]}><span>{back[1]}</span></span>
          </Link>
          <Link className="gh-btn gh-btn--ghost" to="/">
            <span className="roll" data-label="Go home"><span>Go home</span></span>
          </Link>
        </div>
      </main>
    </PageFrame>
  );
}
